export function selectSegmentMode(view, segment, mode) {
    return view.get(segment).select(mode);
}
